import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col, Table, InputGroup } from 'react-bootstrap';
import { oneKlicks } from '../../../SDK/oneclick';
import { toast } from 'react-toastify';
import formatDoctorName from '../../../Uitiles/FormatName';
import ImageShow from '../../../Uitiles/ImageShow';
import PaymentModal from './PaymentModal';

const AddInvoiceModel = ({ showAdd, setShowAdd, data = {}, mode, getdata, addbydocter = {}, type = '' }) => {
    console.log("data", data);
    const readOnly = mode === 'view' || mode === 'edit' || !!addbydocter?.id;
    console.log("addbydocter :", addbydocter?.id);
    const doctordata = addbydocter?.id ? addbydocter : "";

    console.log("doctordata :", doctordata);
    const [formData, setFormData] = useState({
        invoiceType: doctordata ? 'Invoice_for_Package' : data.invoiceType || (addbydocter?.id ? 'Invoice_for_Package' : 'Invoice'),
        userType: doctordata ? 'doctor' : data.userType || (addbydocter?.id ? 'doctor' : ''),
        client: data.client || '',
        amount: data.amount || 0,
        dueDate: data.dueDate || '',
        description: data.description || '',
        tax_type_cgst: data.tax_type_cgst || 'false',
        tax_type_sgst: data.tax_type_sgst || 'false',
        tax_type_igst: data.tax_type_igst || 'false',
        tax_type_tax: data.tax_type_tax || '',

        tax_rate_cgst: data.tax_rate_cgst || 0,
        tax_rate_sgst: data.tax_rate_sgst || 0,
        tax_rate_igst: data.tax_rate_igst || 0,
        tax_rate_tax: data.tax_rate_tax || 0,
        tax_amount_cgst: data.tax_amount_cgst || 0,
        tax_amount_sgst: data.tax_amount_sgst || 0,
        tax_amount_igst: data.tax_amount_igst || 0,
        tax_amount_tax: data.tax_amount_tax || 0,
        total_tax_amount: data.total_tax_amount || 0,
        total_amount: data.total_amount || 0,
        discount: data.discount || "",
        discount_amount: data.discount_amount || ""


    });
    console.log("formData :", formData);
    const [clientList, setClientList] = useState([]);
    const [searchClient, setSearchClient] = useState('');
    const [client, setClient] = useState({});
    const [packageList, setPackageList] = useState([]);
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [clientbillingdetails, setClientbillingdetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentHistory, setPaymentHistory] = useState([]);

    // Reset all inputs when modal closes
    const handleClose = () => {
        setShowAdd(false);
        setFormData({
            invoiceType: '',
            userType: '',
            client: '',
            amount: 0,
            dueDate: '',
            description: '',
            tax_type_cgst: 'false',
            tax_type_sgst: 'false',
            tax_type_igst: 'false',
            tax_type_tax: '',
            tax_rate_cgst: 0,
            tax_rate_sgst: 0,
            tax_rate_igst: 0,
            tax_rate_tax: 0,
            tax_amount_cgst: 0,
            tax_amount_sgst: 0,
            tax_amount_igst: 0,
            tax_amount_tax: 0,
            total_tax_amount: 0,
            total_amount: 0,
            discount: '',
            discount_amount: ''
        });
        setInvoiceItems([]);
        setClientbillingdetails([]);
        setClientList([]);
        setSearchClient('');
        setClient({});
        setPackageList([]);
    };

    useEffect(() => {
        if (data.id) {
            getInvoiceItems(data.id);
            getClientbillingdetails(data.client);
            getClients();
            getPaymentHistory(data.id);
        }
    }, [data.id]);

    useEffect(() => {
        if (doctordata) {
            setFormData(prev => ({
                ...prev,
                invoiceType: type == 'doctor' ? 'Invoice_for_Package' : 'Invoice',
                userType: type == 'doctor' ? 'doctor' : 'hospital',
                client: doctordata.id
            }));
            setClient(doctordata);
            setSearchClient(formatDoctorName(doctordata.display_name));
            getClientbillingdetails(doctordata.id);
            getClients(formatDoctorName(doctordata.display_name), type == 'doctor' ? 'doctor' : 'hospital');
            getPaymentHistory(data.id);

        }
    }, [doctordata]);

    const handleSubmit = async (e) => {

        // if mode is edit then update the invoice based on the data.id
        e.preventDefault();
        setLoading(true);
        const tableSchema = "";
        const tableName = "invoices";
        const dataupdate = {
            ...formData,
            status: "pending",
            paid_amount: 0

        };
        if (mode == 'edit') {
            delete dataupdate.updated_at;
            delete dataupdate.created_at;
        }


        try {
            let response;
            if (mode === 'edit') {
                console.log("dataupdate", dataupdate);
                const conditions =
                    { ...(data.id ? { id: data.id } : {}) };
                console.log("conditions", conditions);
                if (mode === 'edit') {
                    delete dataupdate.id;
                    delete dataupdate.updated_at;
                    delete dataupdate.created_at;
                }
                response = await oneKlicks.update(tableSchema, tableName, dataupdate, conditions);
            } else {
                const conditions = {};
                response = await oneKlicks.create(tableSchema, tableName, dataupdate, conditions);
            }

            let invoiceItemResponse;
            if (response.success) {
                let invoiceId;
                if (mode == 'edit') {
                    invoiceId = data.id;
                } else {
                    invoiceId = response.insertedData.id;
                }

                // Save invoice items sequentially
                for (const item of invoiceItems) {
                    const invoiceItemData = {
                        ...item,
                        invoice_id: invoiceId, // ✅ attach invoice_id
                        status: "pending"
                    };
                    if (mode == 'edit') {
                        delete invoiceItemData.id;
                        delete invoiceItemData.updated_at;
                        delete invoiceItemData.created_at;
                    }



                    if (mode == 'edit') {
                        const tableSchema = '';
                        const tableName = 'invoice_items';
                        const conditions = { ...(item?.id ? { id: item?.id } : {}) };
                        if (item?.id) {
                            invoiceItemResponse = await oneKlicks.update(tableSchema, tableName, invoiceItemData, conditions);
                        } else {
                            invoiceItemResponse = await oneKlicks.create(tableSchema, tableName, invoiceItemData, conditions);
                        }

                    } else {
                        const tableSchema = '';
                        const tableName = 'invoice_items';
                        const conditions = {};
                        invoiceItemResponse = await oneKlicks.create(tableSchema, tableName, invoiceItemData, conditions);
                    }

                    console.log("invoiceItemResponse :", invoiceItemResponse);

                    if (!invoiceItemResponse.success) {
                        toast.error("Failed to create an invoice item");
                    }
                }

                if (doctordata) {
                    const tableSchema = '';
                    const tableName = 'user_package';
                    const conditions = { user_id: doctordata.id };
                    const packageData = {
                        type: "invoice_for_package",
                        user_id: doctordata.id,
                        invoice_id: invoiceItemResponse.insertedData.id,
                        package_id: invoiceItems[0].packageId,
                        status: "active",
                    };
                    const packageResponse = await oneKlicks.create(tableSchema, tableName, packageData, conditions);

                    if (!packageResponse.success) {
                        toast.error("Failed to create a package");
                    }
                }

                toast.success("Invoice created successfully!");
                setShowAdd(false);
                getdata();
            } else {
                toast.error("Failed to create invoice");
            }

            console.log("formData", formData);
            console.log("invoiceItems", invoiceItems);
        } catch (err) {
            console.error("Error creating invoice:", err);
            toast.error("Something went wrong while creating invoice");
        } finally {
            setLoading(false);
        }
    };


    const handleClienttype = (type) => {
        setClientList([]);
        setSearchClient('');
        getClients('', type);
    };

    const handleClientChange = (value) => {
        setClient({});
        setClientList([]);
        setSearchClient(value);
        getClients(value, formData.userType);
    };

    const handleClientSelect = (c) => {
        setClientList([]);
        setClient(c);
        setSearchClient(formatDoctorName(c.display_name));
        setFormData(prev => ({
            ...prev,
            client: c.id
        }));
        getClientbillingdetails(c.id);

        // Update existing invoice items if they depend on doctor's price
        if (invoiceItems.length > 0) {
            const updatedItems = invoiceItems.map((item, idx) => {
                const pkg = packageList.find(p => String(p.id) === String(item.packageId));
                let price = Number(pkg?.price || 0);

                // If package price is 0, use doctor's starting price
                if (price === 0 && c?.starting_price) {
                    price = Number(c.starting_price);
                }

                if (price !== item.price) {
                    // Recalculate totals for this item
                    const cgstRate = formData.tax_type_cgst === 'true' ? Number(formData.tax_rate_cgst || 0) : 0;
                    const sgstRate = formData.tax_type_sgst === 'true' ? Number(formData.tax_rate_sgst || 0) : 0;
                    const igstRate = formData.tax_type_igst === 'true' ? Number(formData.tax_rate_igst || 0) : 0;
                    const taxRate = formData.tax_type_tax === 'true' ? Number(formData.tax_rate_tax || 0) : 0;

                    const taxAmountCgst = (price * cgstRate) / 100;
                    const taxAmountSgst = (price * sgstRate) / 100;
                    const taxAmountIgst = (price * igstRate) / 100;
                    const taxAmountTax = (price * taxRate) / 100;

                    const totalTaxAmount = taxAmountCgst + taxAmountSgst + taxAmountIgst + taxAmountTax;
                    const itemTotal = price + totalTaxAmount;
                    const processingFee = (itemTotal * 2.5) / 100;
                    const finalAmount = itemTotal + processingFee;

                    return {
                        ...item,
                        price,
                        tax_amount_cgst: cgstRate ? taxAmountCgst : '',
                        tax_amount_sgst: sgstRate ? taxAmountSgst : '',
                        tax_amount_igst: igstRate ? taxAmountIgst : '',
                        tax_amount_tax: taxRate ? taxAmountTax : '',
                        total_amount: finalAmount,
                        processing_fee: processingFee,
                        processing_fee_percentage: 2.5
                    };
                }
                return item;
            });

            // Calculate global totals
            const totalAmountSum = updatedItems.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
            const totalTaxAmountSum = updatedItems.reduce((sum, item) =>
                sum + (Number(item.tax_amount_cgst) || 0) +
                (Number(item.tax_amount_sgst) || 0) +
                (Number(item.tax_amount_igst) || 0) +
                (Number(item.tax_amount_tax) || 0), 0);

            const grossTotal = totalAmountSum + totalTaxAmountSum;

            setFormData(prev => ({
                ...prev,
                amount: totalAmountSum,
                total_tax_amount: totalTaxAmountSum,
                total_amount: grossTotal
            }));
            setInvoiceItems(updatedItems);
        }
    };

    const getClients = async (name = '', type = '') => {
        const tableSchema = '';
        const tableName = 'users';
        const conditions = {
            ...(data.client ? { user_type: data.userType } : { user_type: type }),
            ...(data.client ? { id: data.client } : {})
        };
        const orderBy = 'id DESC';
        const search = name
            ? { display_name: name, email: name, phone: name }
            : {};
        const pagination = {};
        const margedata = [];
        console.log("getClients conditions:", conditions);
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        console.log("getClients response:", response);
        if (response.success) {
            if (data.client) {
                setClient(response.data[0]);
                setSearchClient(formatDoctorName(response.data[0].display_name));
            }
            setClientList(response.data);
        } else {
            setClientList([]);
        }
    };

    const getClientbillingdetails = async (id) => {
        try {
            const tableSchema = '';
            const tableName = 'users_billing_details';
            const conditions = { user_id: id };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                setClientbillingdetails(response.data);
                if (response.data.country === 'India') {
                    if (response.data.state === 'Telangana') {
                        setFormData(prev => ({
                            ...prev,
                            tax_type_cgst: 'true',
                            tax_type_sgst: 'true',
                            tax_rate_cgst: 9,
                            tax_rate_sgst: 9
                        }));
                    } else {
                        setFormData(prev => ({
                            ...prev,
                            tax_type: 'IGST',
                            tax_type_igst: 'true',
                            tax_rate: 18
                        }));
                    }
                } else {
                    setFormData(prev => ({
                        ...prev,
                        tax_type_igst: 'true',
                        tax_rate_igst: 18
                    }));
                }

            } else {
                setClientbillingdetails([]);
            }
        } catch (error) {
            console.error("Error fetching client billing details:", error);
            toast.error("Failed to fetch client billing details");
        }
    };

    useEffect(() => {
        getPackages();
    }, []);



    const getInvoiceItems = async (id) => {
        try {
            const tableSchema = '';
            const tableName = 'invoice_items';
            const conditions = { invoice_id: id };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                setInvoiceItems(response.data);
            } else {
                setInvoiceItems([]);
            }
        } catch (error) {
            console.error("Error fetching invoice items:", error);
        }
    };

    const getPackages = async () => {
        try {
            const tableSchema = '';
            const tableName = 'packages';
            const conditions = {};
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                setPackageList(response.data);
            } else {
                setPackageList([]);
            }
        } catch (error) {
            console.error("Error fetching packages:", error);
            toast.error("Failed to fetch packages");
        }
    };

    const getPaymentHistory = async (invoiceId) => {
        try {
            const tableSchema = '';
            const tableName = 'invoice_payments';
            const conditions = { invoice_id: invoiceId };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                setPaymentHistory(response.data);
            } else {
                setPaymentHistory([]);
            }
        } catch (error) {
            console.error("Error fetching payment history:", error);
        }
    };

    const handlePaymentSuccess = () => {
        getPaymentHistory(data.id);
        getdata(); // Refresh the invoice list
        toast.success("Payment recorded successfully!");
    };

    const handleAddInvoiceItem = () => {
        setInvoiceItems([...invoiceItems, { packageId: '', name: '', period: '', price: '' }]);
    };

    const handleInvoiceItemChange = (index, packageId) => {
        // Use String comparison to avoid type mismatch (ID could be number or string)
        const pkg = packageList.find(p => String(p.id) === String(packageId));
        let price = Number(pkg?.price || 0);

        // If package price is 0, fallback to doctor's starting price
        if (price === 0 && client?.starting_price) {
            price = Number(client.starting_price);
            toast.info(`Assigned doctor's base price: ₹${price}`);
        }

        // Convert tax rates to numbers only if enabled
        const cgstRate = formData.tax_type_cgst === 'true' ? Number(formData.tax_rate_cgst || 0) : 0;
        const sgstRate = formData.tax_type_sgst === 'true' ? Number(formData.tax_rate_sgst || 0) : 0;
        const igstRate = formData.tax_type_igst === 'true' ? Number(formData.tax_rate_igst || 0) : 0;
        const taxRate = formData.tax_type_tax === 'true' ? Number(formData.tax_rate_tax || 0) : 0;

        // Tax amounts
        const taxAmountCgst = (price * cgstRate) / 100;
        const taxAmountSgst = (price * sgstRate) / 100;
        const taxAmountIgst = (price * igstRate) / 100;
        const taxAmountTax = (price * taxRate) / 100;

        // Total
        const totalAmount = price + taxAmountCgst + taxAmountSgst + taxAmountIgst + taxAmountTax;
        const totalTaxAmount = taxAmountCgst + taxAmountSgst + taxAmountIgst + taxAmountTax;

        const processingFee = (totalAmount * 2.5) / 100;
        const processingFeePercentage = 2.5;
        const processingFeeAmount = totalAmount + processingFee;

        // Recalculate totals from all invoice items
        const updatedItems = [...invoiceItems];
        updatedItems[index] = {
            packageId,
            name: pkg?.name || '',
            period: pkg?.period || '',
            price,
            tax_rate_cgst: cgstRate || '',
            tax_rate_sgst: sgstRate || '',
            tax_rate_igst: igstRate || '',
            tax_rate_tax: taxRate || '',
            tax_amount_cgst: cgstRate ? taxAmountCgst : '',
            tax_amount_sgst: sgstRate ? taxAmountSgst : '',
            tax_amount_igst: igstRate ? taxAmountIgst : '',
            tax_amount_tax: taxRate ? taxAmountTax : '',
            total_amount: processingFeeAmount,
            processing_fee: processingFee,
            processing_fee_percentage: processingFeePercentage
        };

        // Calculate totals from all items
        const totalAmountSum = updatedItems.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
        const totalTaxCgst = updatedItems.reduce((sum, item) => sum + (Number(item.tax_amount_cgst) || 0), 0);
        const totalTaxSgst = updatedItems.reduce((sum, item) => sum + (Number(item.tax_amount_sgst) || 0), 0);
        const totalTaxIgst = updatedItems.reduce((sum, item) => sum + (Number(item.tax_amount_igst) || 0), 0);
        const totalTaxTax = updatedItems.reduce((sum, item) => sum + (Number(item.tax_amount_tax) || 0), 0);
        const totalTaxAmountSum = totalTaxCgst + totalTaxSgst + totalTaxIgst + totalTaxTax;
        const grossTotal = totalAmountSum + totalTaxAmountSum;

        setFormData(prev => ({
            ...prev,
            amount: totalAmountSum,
            tax_amount_cgst: totalTaxCgst,
            tax_amount_sgst: totalTaxSgst,
            tax_amount_igst: totalTaxIgst,
            tax_amount_tax: totalTaxTax,
            total_tax_amount: totalTaxAmountSum,
            total_amount: grossTotal
        }));

        setInvoiceItems(updatedItems);
    };

    const handleRemoveInvoiceItem = async (index, id = '') => {
        const updated = [...invoiceItems];
        updated.splice(index, 1);

        // Recalculate totals from remaining items
        const totalAmountSum = updated.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
        const totalTaxCgst = updated.reduce((sum, item) => sum + (Number(item.tax_amount_cgst) || 0), 0);
        const totalTaxSgst = updated.reduce((sum, item) => sum + (Number(item.tax_amount_sgst) || 0), 0);
        const totalTaxIgst = updated.reduce((sum, item) => sum + (Number(item.tax_amount_igst) || 0), 0);
        const totalTaxTax = updated.reduce((sum, item) => sum + (Number(item.tax_amount_tax) || 0), 0);
        const totalTaxAmountSum = totalTaxCgst + totalTaxSgst + totalTaxIgst + totalTaxTax;
        const grossTotal = totalAmountSum + totalTaxAmountSum;

        setFormData(prev => ({
            ...prev,
            amount: totalAmountSum,
            tax_amount_cgst: totalTaxCgst,
            tax_amount_sgst: totalTaxSgst,
            tax_amount_igst: totalTaxIgst,
            tax_amount_tax: totalTaxTax,
            total_tax_amount: totalTaxAmountSum,
            total_amount: grossTotal
        }));

        if (id) {
            const tableSchema = '';
            const tableName = 'invoice_items';
            const conditions = { id: id };
            const invoiceItemResponse = await oneKlicks.delete(tableSchema, tableName, conditions);
            if (!invoiceItemResponse.success) {
                toast.error("Failed to delete invoice item");
            }
        }
        setInvoiceItems(updated);
    };

    const handleDiscountChange = (value, type) => {
        const discount = Number(value) || 0;
        const grossTotal = Number(formData.amount || 0) + Number(formData.total_tax_amount || 0);

        if (type === "percentage") {
            if (discount > 100) {
                toast.error("Discount cannot be greater than 100%");
                return;
            }
            if (discount < 0) {
                toast.error("Discount cannot be less than 0%");
                return;
            }

            const discountAmount = (grossTotal * discount) / 100;
            const netTotal = grossTotal - discountAmount;

            setFormData(prev => ({
                ...prev,
                discount: discount,               // %
                discount_amount: discountAmount,  // ₹
                total_amount: netTotal
            }));
        } else if (type === "amount") {
            if (discount > grossTotal) {
                toast.error("Discount cannot be greater than the total amount");
                return;
            }
            if (discount < 0) {
                toast.error("Discount cannot be less than 0");
                return;
            }

            const discountPercentage = grossTotal > 0 ? (discount / grossTotal) * 100 : 0;
            const netTotal = grossTotal - discount;

            setFormData(prev => ({
                ...prev,
                discount: discountPercentage, // auto-sync back to %
                discount_amount: discount,    // ₹
                total_amount: netTotal
            }));
        }
    };



    return (
        <Modal show={showAdd} onHide={handleClose} size="xlxo" className='add-invoice-modal'>
            <Modal.Header  >
                <Modal.Title>Create New Invoice</Modal.Title>
                <Button variant="secondary" onClick={handleClose}>
                    <i className="fa fa-times"></i>
                </Button>
            </Modal.Header>
            <Form onSubmit={handleSubmit} disabled={loading}>
                <Modal.Body>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="wl-100">
                                <Form.Label>Invoice Type *</Form.Label>
                                <Form.Select
                                    value={formData.invoiceType}
                                    className='wl-100'
                                    // onChange={(e) => e.preventDefault()} // ignore selection
                                    onChange={(e) => {
                                        if (readOnly) {
                                            e.preventDefault();
                                        } else {
                                            setFormData({ ...formData, invoiceType: e.target.value });
                                        }
                                    }}
                                    required
                                >
                                    <option value="">Select Invoice Type</option>
                                    <option value="Invoice">Invoice</option>
                                    <option value="Receipt">Receipt</option>
                                    <option value="Invoice_for_Package">Invoice for Package</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="wl-100">
                                <Form.Label>User Type *</Form.Label>
                                <Form.Select
                                    value={formData.userType}
                                    className='wl-100'
                                    onChange={(e) => {
                                        if (readOnly) {
                                            e.preventDefault();
                                        } else {
                                            setFormData({ ...formData, userType: e.target.value });
                                            handleClienttype(e.target.value);
                                        }
                                    }}
                                    required
                                >
                                    <option value="">Select User Type</option>
                                    <option value="hospital">Hospital</option>
                                    <option value="investor">Investor</option>
                                    <option value="doctor">Doctor</option>
                                    <option value="other">Other</option>
                                    <option value="client">Client</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Doctor</Form.Label>
                                <Form.Control
                                    className='wl-100'
                                    type="text"
                                    placeholder="Enter doctor"
                                    readOnly={readOnly}
                                    value={searchClient || ''}
                                    onChange={(e) => {
                                        if (readOnly) {
                                            e.preventDefault();
                                        } else {
                                            handleClientChange(e.target.value);
                                        }
                                    }}
                                />
                                {clientList.length > 0 && mode != 'view' && (
                                    <div className="border rounded mt-2" style={{ maxHeight: 240, overflowY: 'auto' }}>
                                        {clientList.map((d) => (
                                            <button
                                                key={d.id}
                                                type="button"
                                                className="dropdown-item d-flex align-items-center"
                                                onClick={() => {
                                                    if (readOnly) {
                                                        return;
                                                    } else {
                                                        handleClientSelect(d);
                                                    }
                                                }}
                                                style={{ width: '100%', textAlign: 'left', paddingLeft: 2 }}
                                            >
                                                <ImageShow url={d.profile_photo_url} height={40} width={40} style={{ borderRadius: '50%' }} />
                                                <div className="d-flex flex-column ms-2" style={{ borderBottom: '1px solid #0000001f' }}>
                                                    <div className="doctor-name" style={{ fontWeight: 'bold', fontSize: 14, marginBottom: -7 }}>
                                                        {formatDoctorName(d.display_name)}
                                                    </div>
                                                    <div className="doctor-address text-muted" style={{ fontSize: 10 }}>
                                                        {d.address}
                                                    </div>
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </Form.Group>
                            <Row style={{ marginLeft: 0, marginTop: 0 }}>
                                {client.id && mode != 'view' && (
                                    <div className="mt-2 d-flex align-items-center gap-2 mr-5">
                                        <ImageShow url={client.profile_photo_url} height={40} width={40} style={{ borderRadius: '50%' }} />
                                        <div className="d-flex flex-column ml-2">
                                            <div className="doctor-name" style={{ fontWeight: 'bold', fontSize: 14, marginBottom: -7 }}>
                                                {formatDoctorName(client.display_name)}
                                            </div>
                                            <div className="doctor-address text-muted" style={{ fontSize: 10 }}>{client.email}</div>
                                            
                                        </div>
                                    </div>
                                )}
                                {clientbillingdetails.length > 0 ? (
                                    <></>
                                ) : (
                                    <div className="mt-2 d-flex align-items-center gap-2">
                                        <div className="doctor-address" style={{ fontSize: 20, color: 'red' }}>No billing details found</div>
                                    </div>
                                )}
                            </Row>

                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Due Date *</Form.Label>
                                <Form.Control
                                    className='wl-100'
                                    type="date"
                                    readOnly={mode == 'view'}
                                    value={formData.dueDate}
                                    onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Invoice Items Table */}
                    <Row>
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6>Invoice Items</h6>
                                <Button
                                    size="sm"
                                    onClick={handleAddInvoiceItem}
                                    disabled={clientbillingdetails.length === 0 || mode == 'view'}
                                >
                                    + Add Package
                                </Button>
                            </div>

                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>Package</th>
                                        <th>Duration</th>
                                        <th>Price</th>
                                        {formData.tax_type_cgst === 'true' && <th>CGST %</th>}
                                        {formData.tax_type_sgst === 'true' && <th>SGST %</th>}
                                        {formData.tax_type_igst === 'true' && <th>IGST %</th>}
                                        {formData.tax_type_tax === 'true' && <th>Tax %</th>}
                                        {formData.tax_type_cgst === 'true' && <th>CGST Amount</th>}
                                        {formData.tax_type_sgst === 'true' && <th>SGST Amount</th>}
                                        {formData.tax_type_igst === 'true' && <th>IGST Amount</th>}
                                        {formData.tax_type_tax === 'true' && <th>Tax Amount</th>}
                                        <th>Total Amount</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoiceItems.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>
                                                <Form.Select
                                                    value={item.packageId}
                                                    onChange={(e) => handleInvoiceItemChange(idx, e.target.value)}
                                                    readOnly={mode == 'view'}
                                                    required
                                                >
                                                    <option value="">Select Package</option>
                                                    {packageList.map((p) => (
                                                        <option key={p.id} value={p.id}>
                                                            {p.name}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </td>
                                            <td>{item.period}</td>
                                            <td>{item.price}</td>
                                            {formData.tax_type_cgst === 'true' && <td>{item.tax_rate_cgst}</td>}
                                            {formData.tax_type_sgst === 'true' && <td>{item.tax_rate_sgst}</td>}
                                            {formData.tax_type_igst === 'true' && <td>{item.tax_rate_igst}</td>}
                                            {formData.tax_type_tax === 'true' && <td>{item.tax_rate_tax}</td>}
                                            {formData.tax_type_cgst === 'true' && <td>{item.tax_amount_cgst}</td>}
                                            {formData.tax_type_sgst === 'true' && <td>{item.tax_amount_sgst}</td>}
                                            {formData.tax_type_igst === 'true' && <td>{item.tax_amount_igst}</td>}
                                            {formData.tax_type_tax === 'true' && <td>{item.tax_amount_tax}</td>}
                                            <td>{item.total_amount}</td>
                                            <td>
                                                <Button
                                                    size="sm"
                                                    variant="danger"
                                                    className={item.id}
                                                    onClick={() => handleRemoveInvoiceItem(idx, item.id)}
                                                >
                                                    {data.client ? mode == 'view' ? 'View' : 'Delete' : 'Remove'}
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}

                                    {invoiceItems.length === 0 && (
                                        <tr>
                                            <td colSpan={12} className="text-center text-muted">
                                                No items added
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>

                    {/* Payment Section - Only show in view mode */}
                    {mode === 'view' && data.id && (
                        <Row>
                            <Col md={12}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6>Payment History</h6>
                                    <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => setShowPaymentModal(true)}
                                        disabled={data.status === 'paid'}
                                    >
                                        {data.status === 'paid' ? 'Fully Paid' : 'Record Payment'}
                                    </Button>
                                </div>

                                {paymentHistory.length > 0 ? (
                                    <Table bordered size="sm">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Amount</th>
                                                <th>Payment Source</th>
                                                <th>Reference</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paymentHistory.map((payment, idx) => (
                                                <tr key={idx}>
                                                    <td>{new Date(payment.payment_date).toLocaleDateString()}</td>
                                                    <td>₹{payment.amount}</td>
                                                    <td>{payment.payment_source.toUpperCase()}</td>
                                                    <td>{payment.reference_number || '-'}</td>
                                                    <td>
                                                        <span className={`badge ${payment.status === 'completed' ? 'bg-success' : 'bg-warning'}`}>
                                                            {payment.status}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <div className="text-center text-muted p-3">
                                        No payments recorded yet
                                    </div>
                                )}

                                {/* Payment Summary */}
                                <div className="mt-3 p-3 bg-light rounded">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <strong>Total Amount:</strong> ₹{data.total_amount || 0}
                                        </div>
                                        <div className="col-md-4">
                                            <strong>Paid Amount:</strong> ₹{data.paid_amount || 0}
                                        </div>
                                        <div className="col-md-4">
                                            <strong>Remaining:</strong> ₹{(data.total_amount || 0) - (data.paid_amount || 0)}
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <strong>Status:</strong>
                                        <span className={`badge ms-2 ${data.status === 'paid' ? 'bg-success' :
                                            data.status === 'partial_payment' ? 'bg-warning' :
                                                'bg-danger'
                                            }`}>
                                            {data.status === 'paid' ? 'Fully Paid' :
                                                data.status === 'partial_payment' ? 'Partial Payment' :
                                                    'Pending'}
                                        </span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Amount (₹) *</Form.Label>
                                <Form.Control
                                    type="number"
                                    readOnly={true}
                                    step="0.01"
                                    value={formData.amount}
                                    onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <div className="d-flex space-between" style={{ justifyContent: 'space-between' }}>
                                <p className="mb-0">Total: </p>
                                <p className="mb-0 text-center"></p>
                                <p className="mb-0 text-right">₹{formData.amount}</p>
                            </div>
                            <hr style={{ marginBottom: '3px', marginTop: '3px' }} />
                            {formData.tax_type_cgst === 'true' && (
                                <div className="d-flex space-between" style={{ justifyContent: 'space-between' }}>
                                    <p className="mb-0">CGST: </p>
                                    <p className="mb-0 text-center">{formData.tax_rate_cgst}%</p>
                                    <p className="mb-0 text-right">₹{formData.tax_amount_cgst}</p>
                                </div>
                            )}
                            {formData.tax_type_sgst === 'true' && (
                                <div className="d-flex space-between" style={{ justifyContent: 'space-between' }}>
                                    <p className="mb-0">SGST: </p>
                                    <p className="mb-0 text-center">{formData.tax_rate_sgst}%</p>
                                    <p className="mb-0 text-right">₹{formData.tax_amount_sgst}</p>
                                </div>
                            )}
                            {formData.tax_type_igst === 'true' && (
                                <div className="d-flex space-between" style={{ justifyContent: 'space-between' }}>
                                    <p className="mb-0">IGST: </p>
                                    <p className="mb-0 text-center">{formData.tax_rate_igst}%</p>
                                    <p className="mb-0 text-right">₹{formData.tax_amount_igst}</p>
                                </div>
                            )}
                            {formData.tax_type_tax === 'true' && (
                                <div className="d-flex space-between" style={{ justifyContent: 'space-between' }}>
                                    <p className="mb-0">Tax: </p>
                                    <p className="mb-0 text-center">{formData.tax_rate_tax}%</p>
                                    <p className="mb-0 text-right">₹{formData.tax_amount_tax}</p>
                                </div>
                            )}
                            <hr style={{ marginBottom: '3px', marginTop: '3px' }} />
                            <div className="d-flex space-between" style={{ justifyContent: 'space-between' }}>
                                <p className="mb-0">Tax Amount: </p>
                                <p className="mb-0 text-right">₹{formData.total_tax_amount}</p>
                            </div>
                            <hr style={{ marginBottom: '3px', marginTop: '3px' }} />
                            <div className="d-flex space-between" style={{ justifyContent: 'space-between' }}>
                                <p className="mb-0">Discount %: </p>
                                <InputGroup
                                    className='mb-0'
                                    style={{ width: '100px' }}
                                >
                                    <Form.Control
                                        type="text"
                                        step="1"
                                        readOnly={mode == 'view'}
                                        value={formData.discount}
                                        onChange={(e) => handleDiscountChange(e.target.value, "percentage")}
                                    />
                                </InputGroup>
                            </div>
                            <div className="d-flex space-between" style={{ justifyContent: 'space-between' }}>
                                <p className="mb-0">Discount Amount: </p>
                                <InputGroup
                                    className='mb-0'
                                    style={{ width: '100px' }}
                                >
                                    <Form.Control
                                        type="text"
                                        step="1"
                                        readOnly={mode == 'view'}
                                        value={formData.discount_amount}
                                        onChange={(e) => handleDiscountChange(e.target.value, "amount")}
                                    />
                                </InputGroup>
                            </div>
                            <hr style={{ marginBottom: '3px', marginTop: '3px' }} />
                            <div className="d-flex space-between" style={{ justifyContent: 'space-between' }}>
                                <p className="mb-0">Grand Total: </p>
                                <p className="mb-0 text-right">₹{formData.total_amount}</p>
                            </div>
                        </Col>

                    </Row>

                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={formData.description}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            placeholder="Enter invoice description..."
                            readOnly={mode == 'view'}
                        />
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAdd(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" disabled={loading}>
                        {mode == 'edit' ? 'Update Invoice' : 'Create Invoice'}
                    </Button>
                </Modal.Footer>
            </Form>

            {/* Payment Modal */}
            <PaymentModal
                show={showPaymentModal}
                setShow={setShowPaymentModal}
                invoiceData={data}
                onPaymentSuccess={handlePaymentSuccess}
            />
        </Modal>
    );
};

export default AddInvoiceModel;
